import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
} from '@mui/material'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ReactComponent as DownCarot } from '../assets/images/icons/down.svg'
import facebookIcon from '../assets/images/icons/facebook.svg'
import instagramIcon from '../assets/images/icons/instagram.svg'
import linkedinIcon from '../assets/images/icons/linkedin-black.png'
import NavigationMenu from '../components/common/NavigationMenu'
import GetInTouch from '../components/common/get-in-touch'
import Loader from '../components/common/loader'
import SearchBar from '../components/search-bar'
import { GetDynamicNavigation } from '../services/contentStack'
import { ContactEmail, ContactUsNo } from '../utils/constants'
import {
    CLICK_ID,
    NAVIGATION_TYPE,
    ROUTES,
    SOCIAL_MEDIA_URL,
} from '../utils/constants/enum'
import { transformToNavigationLink } from '../utils/helper-functions'
import {
    SingleGroupLink,
    SingleGroupLinkItem,
} from '../utils/types/ContentStack'
import { FooterNavType, NavItem, PRIVACY, TERMS_OF_USE } from './_nav'
import './footer.scss'

const Footer = () => {
    const location = useLocation()
    const isSearchPage = location.pathname.includes(ROUTES.SEARCH)
    const [expanded, setExpanded] = useState<string | false>(false)
    const [footerNavs, setFooterNavs] = useState<Array<FooterNavType>>()

    const [isLoading, setLoading] = useState<boolean>(true)
    let CURRENT_YEAR = moment().format('YYYY')

    const getData = useCallback(async () => {
        try {
            const res = await GetDynamicNavigation(NAVIGATION_TYPE.FOOTER)
            if (res) {
                const NavArr = res?.group_navigation?.map(
                    (e: SingleGroupLink) => {
                        return {
                            heading: e.title,
                            navs: e.group.map((item: SingleGroupLinkItem) =>
                                transformToNavigationLink(item)
                            ),
                        }
                    }
                )

                setFooterNavs(NavArr)
            }
        } catch (error) {
            // error handling
        } finally {
            setLoading(false)
        }
    }, [])
    useEffect(() => {
        const CookiefloatingBtn = document.getElementById('ot-sdk-btn-floating')
        if (CookiefloatingBtn) {
            CookiefloatingBtn.style.display = 'none'
        }
    }, [])
    useEffect(() => {
        getData().catch((error) => console.log(error))
    }, [getData])

    const handleChange =
        (panel: string) =>
        (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false)
        }

    useEffect(() => {
        setExpanded(false)
    }, [location])

    if (isLoading) {
        return <Loader />
    }

    const socialIcons = (
        <div className="social-icons-outer-wrapper">
            <span className="social-title">#Hydrafacial</span>
            <div className="social-icons">
                <span>
                    <a
                        href={SOCIAL_MEDIA_URL.FACEBOOK}
                        target="_blank"
                        id={CLICK_ID.FACEBOOK_FOOTER}
                        rel="noreferrer"
                    >
                        <img src={facebookIcon} alt="Facebook Icon" />
                    </a>
                </span>
                <span>
                    <a
                        href={SOCIAL_MEDIA_URL.INSTAGRAM}
                        target="_blank"
                        id={CLICK_ID.INSTAGRAM_FOOTER}
                        rel="noreferrer"
                    >
                        <img src={instagramIcon} alt="Instagram Icon" />
                    </a>
                </span>
                <span className="linkedin">
                    <a
                        href={
                            'https://www.linkedin.com/company/thehydrafacialcompany'
                        }
                        target="_blank"
                        id={'linkedin_footer'}
                        rel="noreferrer"
                    >
                        <img src={linkedinIcon} alt="LinkedIn Icon" />
                    </a>
                </span>
            </div>
        </div>
    )
    return (
        <footer>
            <hr className="hide-mobile hide-tablet" />
            <div className="hide-desktop footer-mobile-links">
                {footerNavs?.map((colValue) => (
                    <Accordion
                        className="footer-accordian"
                        key={colValue?.heading}
                        expanded={expanded === colValue?.heading}
                        onChange={handleChange(colValue?.heading)}
                    >
                        <AccordionSummary
                            expandIcon={<DownCarot />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <div className="footer-head">
                                {colValue?.heading}
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ul>
                                {colValue?.navs.map((nav: NavItem) => (
                                    <NavigationMenu nav={nav} key={nav.key} />
                                ))}
                            </ul>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
            <div className="wrapper">
                <Grid container justifyContent="space-between">
                    <Grid
                        item
                        md={12}
                        lg={8}
                        className="hide-mobile hide-tablet"
                    >
                        <Grid container>
                            {footerNavs?.map((colValue, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={4}
                                    key={colValue?.heading}
                                >
                                    <div className="footer-head">
                                        {colValue?.heading}
                                    </div>
                                    <ul>
                                        {colValue?.navs.map((nav: NavItem) => (
                                            <NavigationMenu
                                                nav={nav}
                                                key={nav.key}
                                            />
                                        ))}
                                    </ul>
                                    {index === 0 && socialIcons}
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    <Grid item md={12} lg={4}>
                        <Grid container className="get-in-touch-section">
                            <Grid item xs={12}>
                                <GetInTouch />
                            </Grid>
                            {!isSearchPage ? (
                                <Grid
                                    item
                                    xs={12}
                                    className="search-bar-container"
                                >
                                    <SearchBar />
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                    <div className="hide-desktop hide-tablet contact-1">
                        <span className="contact-us">{`Contact us:`}</span>
                        <span className="contact-us">{ContactUsNo}</span>
                        <a
                            href={`mailto:${ContactEmail}`}
                            id="orders@hydrafacial_footer"
                        >
                            {ContactEmail}
                        </a>
                    </div>
                    <div className="hide-desktop">{socialIcons}</div>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item xs={12}>
                            <div className="footer-social">
                                <div className="contact-2">
                                    <div>
                                        <span className="hide-mobile ">
                                            {`Copyright © ${CURRENT_YEAR}. Hydrafacial LLC.`}
                                            <span className="all-right-text">
                                                All Rights Reserved.
                                            </span>
                                        </span>
                                        <a
                                            href={PRIVACY.link}
                                            id="privacy_policy_footer"
                                            className={'privacy-link'}
                                        >
                                            {PRIVACY.label}
                                        </a>
                                        <button
                                            id="ot-sdk-btn"
                                            className={`ot-sdk-show-settings`}
                                        >
                                            Cookie Settings
                                        </button>
                                        <a
                                            href={`${TERMS_OF_USE.link}en`}
                                            id="privacy_policy_footer"
                                            className={'privacy-link'}
                                        >
                                            {TERMS_OF_USE.label}
                                        </a>
                                    </div>
                                    <span className="result-text">
                                        <i>
                                            *Results may vary from business to
                                            business
                                        </i>
                                    </span>
                                </div>

                                <span className="hide-desktop hide-tablet">
                                    {`Copyright © ${CURRENT_YEAR}. Hydrafacial LLC.`}
                                    <span className="all-right-text">
                                        All Rights Reserved.
                                    </span>
                                </span>

                                <div className="result-text hide-mobile ">
                                    <span className="contact-us">{`Contact us: ${ContactUsNo} `}</span>
                                    <a
                                        href={`mailto:${ContactEmail}`}
                                        id="orders@hydrafacial_footer"
                                    >
                                        {ContactEmail}
                                    </a>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </footer>
    )
}

export default Footer
